export default "__VITE_ASSET__683e1314__"